import LocalizedLink from '@components/Localization/LocalizedLink'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { NavActiveOptions } from '../HeaderContent'

type HeaderNavigationMainNavProps = {
  onClickItem: (key: NavActiveOptions) => void
}

export const HeaderNavigationMainNav: FC<HeaderNavigationMainNavProps> = ({ onClickItem }) => {
  const { t } = useTranslation(['navigation', 'global', 'other'])

  const linkStyle = cn(
    'outline-none font-special text-[11px] uppercase tracking-[0.28em]',
    'duration-400 transition-all ease-in-out',
    'focus:opacity-100',
    'hover:opacity-50',
  )

  return (
    <div className={cn('hidden lg:flex', 'col-span-3 row-start-2 items-center gap-8 pt-4')}>
      <LocalizedLink href="/rolex" passHref>
        <a className={linkStyle}>Rolex</a>
      </LocalizedLink>
      <LocalizedLink href={t(`rcpo.index.url`, { ns: 'navigation' })}>
        <a className={linkStyle}>Rolex Certified Pre-Owned</a>
      </LocalizedLink>
      <button className={linkStyle} onClick={() => onClickItem('shop')}>
        {t(`mainNav.shop`, { ns: 'navigation' })}
      </button>
      <button className={linkStyle} onClick={() => onClickItem('pre-owned')}>
        Pre-owned
      </button>
      <button className={linkStyle} onClick={() => onClickItem('diamonds')}>
        {t(`mainNav.diamonds`, { ns: 'navigation' })}
      </button>
      <button className={linkStyle} onClick={() => onClickItem('house-of-gassan')}>
        {t(`mainNav.houseOfGassan`, { ns: 'navigation' })}
      </button>
      <LocalizedLink href={t(`tours`, { ns: 'navigation' })}>
        <a className={linkStyle}>Tours</a>
      </LocalizedLink>
    </div>
  )
}
